import { render, staticRenderFns } from "./SoftwareUpdate.vue?vue&type=template&id=8c03d3ec&scoped=true"
import script from "./SoftwareUpdate.vue?vue&type=script&lang=ts"
export * from "./SoftwareUpdate.vue?vue&type=script&lang=ts"
import style0 from "./SoftwareUpdate.vue?vue&type=style&index=0&id=8c03d3ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c03d3ec",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBadge,VBtn,VCol,VIcon,VImg,VOverlay,VProgressCircular,VProgressLinear,VRow,VSheet})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})


/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c03d3ec')) {
      api.createRecord('8c03d3ec', component.options)
    } else {
      api.reload('8c03d3ec', component.options)
    }
    module.hot.accept("./SoftwareUpdate.vue?vue&type=template&id=8c03d3ec&scoped=true", function () {
      api.rerender('8c03d3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SoftwareUpdate.vue"
export default component.exports